import { useSelector } from "react-redux";
import { IStoreState } from "../redux/initialStoreState";

export const useRecordCounts = () => {
	return useSelector(
		(storeState: IStoreState) => storeState.common.recordCounts
	);
};

export const useWhatsappCounts = () => {
	return useSelector(
		(storeState: IStoreState) => storeState.common.whatsappCounts
	);
};

export const usePaymentTransactionCounts = () => {
	return useSelector(
		(storeState: IStoreState) => storeState.common.paymentTransactionCounts
	);
};
